var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { generateQueryParamsStr } from "../../utils/apiUtils";
import { getReportFileTransportConfig } from "../../utils/reportFileDownload";
const GENERATE_EXPORT = 'api/export';
const GET_SET_REPORTS = 'api/reports';
export const exportUnpaidOrdersReportPDF = function (storeId, params, options) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = Object.assign(Object.assign({}, getReportFileTransportConfig(this, options)), { headers: {
                    Authorization: `Bearer ${this.apiToken}`,
                }, params: {
                    responseType: 'blob'
                } });
            const queryParams = generateQueryParamsStr(['store', 'fromDate', 'toDate', 'timezone', 'customerName'], params);
            return yield this.axiosInstance.get(`${GET_SET_REPORTS}/${storeId}/unpaidOrders/export/pdf?${queryParams}`, config);
            // // Create a link element, trigger a download
            // const url = window.URL.createObjectURL(new Blob([response.data]));
            // const link = document.createElement('a');
            // link.href = url;
            // link.setAttribute('download', 'Reporte_Pedidos_Pago_Pendiente.pdf'); // Change the filename here if needed
            // document.body.appendChild(link);
            // link.click();
            // link.remove();
            // return response.data;
        }
        catch (error) {
            throw error;
        }
    });
};
